const Footer = () => {
  const year = new Date().getFullYear()
  return (
    <footer className='footer'>
      <div className='footer-copyright'>© {year} CNC obrábění DUBEN</div>
    </footer>
  )
}

export default Footer
